<template>
    <div>
        <Modal v-model="innerVisible" :width="90" :mask-closable="false" :closable="false" footer-hide>
            <template #header>
                <div>
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div>
                            <h1 style="display: inline-block;">广告素材上传</h1>
                        </div>
                        <div>
                            <Icon type="ios-close" :style="{ fontSize: '30px', cursor: curState.uploading ? 'not-allowed' : 'pointer' }" :size="30"
                                @click="!curState.uploading && handleClickClose(false)" />
                        </div>
                    </div>
                    <div style="margin-top: 10px;display:flex;justify-content: space-between;align-items:center;">
                        <div>
                            <span :style="{
                                padding: '5px 10px',
                                backgroundColor: hasPublishedMaterial ? '#52c41a' : '#f56c6c',
                                color: '#fff',
                                borderRadius: '90px',
                                display: 'inline-block'
                            }">
                                {{ hasPublishedMaterial ? '已发布' : '未发布' }}</span>
                            <span style="margin-left: 20px;color: #333">
                                短剧名称：{{ form.playName }}丨中文名称：{{ form.chineseName || form.parentPlayName }}丨语言：{{ form.langName }}
                            </span>
                        </div>
                        <div style="display:flex;align-items:center;">
                            <div style="color:red;margin-right:15px;" v-if="curState.uploading">
                                上传过程中请勿关闭或离开页面，否则会中断文件传输。</div>
                            <div style="position:relative;">
                                <Button type="primary" :disabled="curState.uploading" @click="handleTriggerUpload">本地上传</Button>
                                <input ref="uploadInputTop" type="file" :multiple="true" style="position:absolute;inset:0;opacity:0;cursor:pointer;"
                                    :disabled="curState.uploading"
                                    @change="handleLocalUpload"
                                    accept=".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi" />
                            </div>
                        </div>
                    </div>
                    <div v-if="curState.uploading" style="display:flex;align-items:center;margin-top:15px;">
                        <span style="flex-shrink:0;margin-right:10px;">上传进度：</span>
                        <Progress :percent="Math.min(99, Math.round(percentProgress))" status="active"
                            style="flex:1;" />
                        <span style="margin-left:10px;flex-shrink:0;">{{ formatPercent }}</span>
                    </div>
                </div>
            </template>
            <div style="background: #fff;padding: 20px;height: calc(65vh);display:flex;flex-direction:column;position:relative;">
                <div v-if="curState.uploading" data-upload-mask style="position:absolute;inset:0;z-index:100;background:rgba(255,255,255,0.001);cursor:not-allowed;"></div>
                <div style="flex:1;overflow:auto;">
                    <div style="display:flex;flex-wrap: wrap;margin: 0 1%;">
                        <div style="padding: 1.2%;box-sizing: border-box;flex: 0 11.11%;width: 11.11%">
                            <div :style="{
                                background: '#fff',
                                height: '22vh',
                                border: curState.uploading ? '1px dashed #e8eaec' : '1px dashed #dcdee2',
                                borderRadius: '5px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: curState.uploading ? 'not-allowed' : 'pointer',
                                position: 'relative'
                            }">
                                <Icon v-if="!curState.uploading" type="ios-add" :size="40" color="#999"></Icon>
                                <input v-if="!curState.uploading" type="file" :multiple="true" style="position:absolute;inset:0;opacity:0;cursor:pointer;"
                                    @change="handleLocalUpload"
                                    accept=".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi" />
                            </div>
                            <div style="text-align: center;margin-top: 10px;font-size:13px;color:#999;line-height:1.4;">
                                添加广告素材
                            </div>
                        </div>
                        <div v-for="(item, index) in pagedData"
                            :key="item.id || index" style="padding: 1.2%;box-sizing: border-box;flex: 0 11.11%;width: 11.11%">
                            <div style="background: #fff;height: 22vh;border:1px solid #e8eaec;border-radius: 5px;overflow:hidden;position:relative">
                                <div v-if="item.status === 'uploading'" style="position:absolute;z-index:20;inset:0;background:#e5e8ec;">
                                    <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                                        <div style="text-align:center;">
                                            <Spin size="large"></Spin>
                                            <div style="margin-top:10px;font-size:14px;color:#999">上传中...</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="item.status === 'fail'" style="position:absolute;z-index:20;inset:0;background:#fef0f0;">
                                    <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
                                        <div style="text-align:center;">
                                            <Icon type="ios-close-circle-outline" :size="40" color="#f56c6c"></Icon>
                                            <div style="margin-top:10px;font-size:14px;color:#f56c6c">上传失败</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="item.fileUrl" style="position:absolute;z-index:10;inset:0">
                                    <div style="width: 100%;height:100%;position:relative">
                                        <div :style="{
                                            position: 'absolute', top: 0, right: 0, background: '#2d8cf0', color: '#fff',
                                            padding: '3px 10px', fontSize: '10px', borderBottomLeftRadius: '5px', zIndex: 5
                                        }">
                                            已上传
                                        </div>
                                        <div v-if="item.materialType === 2" :style="{
                                            position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.75)', color: '#fff',
                                            padding: '2px 8px', fontSize: '10px', borderBottomRightRadius: '5px', zIndex: 5
                                        }">
                                            {{ formatDurationShort(item.displayDuration || item.duration) }}
                                        </div>
                                        <img v-if="item.materialType === 1" :src="resolveFileUrl(item.fileUrl) || item.localCover"
                                            style="width: 100%;height:100%;object-fit: cover;cursor: pointer;"
                                            @click="handlePreviewCard(item)" />
                                        <div v-else-if="item.materialType === 2"
                                            style="width: 100%;height:100%;position:relative;cursor:pointer;">
                                            <img :src="resolveFileUrl(item.coverUrl || item.localCover || '')"
                                                v-if="item.coverUrl || item.localCover"
                                                style="width: 100%;height:100%;" />
                                            <div v-else style="width:100%;height:100%;background:#222;"></div>
                                            <div style="padding: 5px;background: rgba(0,0,0,0.7);border-radius: 5px;position:absolute;
                                                        left:50%;top:50%;transform:translate(-50%,-50%);z-index:4;
                                                    " @click.stop="handlePreviewCard(item)">
                                                <div
                                                    style="border-radius: 90px;border: 2px solid #fff;padding: 2px;">
                                                    <Icon type="ios-play-outline"
                                                        style="font-weight: bold;margin-left: 1px;" :size="20"
                                                        color="#fff" />
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.status !== 'uploading' && item.status !== 'fail' && materialCount > 1" style="position:absolute;left:0;right:0;bottom:0;z-index:6;">
                                            <Button v-if="currentUseItem && currentUseItem.id === item.id"
                                                :disabled="curState.uploading"
                                                @click.stop="handleClickCurrentUse(item)"
                                                size="small"
                                                style="width:100%;background:#f56c6c;color:#fff;border-color:#f56c6c;border-radius:4px 4px 0 0;">
                                                当前使用
                                            </Button>
                                            <Button v-else
                                                :disabled="curState.uploading"
                                                size="small" type="primary" style="width:100%;border-radius:4px 4px 0 0;" @click.stop="handleSetCurrent(item)">
                                                设为当前
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else
                                    style="position: absolute;inset:0;z-index:1;display:flex;align-items: center;justify-content: center;background:#f8f8f9">
                                    <Icon type="ios-image-outline" :size="50" color="#999"></Icon>
                                </div>
                            </div>
                            <div style="margin-top: 10px;font-size:13px;line-height:1.4;">
                                <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;text-align: center;">
                                    <Input v-if="editingItem && editingItem.id === item.id" v-model="editingName"
                                        size="small" ref="renameInput"
                                        :disabled="curState.uploading"
                                        @on-blur="handleFinishRename(item)"
                                        @on-enter="handleFinishRename(item)"
                                        @on-keyup.esc="handleCancelRename"
                                        style="width:100%;" />
                                    <span v-else>{{ item.materialName || item.fileOriginalName || '未命名' }}</span>
                                </div>
                                <div style="display:flex;align-items:center;justify-content:space-between;margin-top:4px;">
                                    <div style="color:#aaa;font-size:11px;white-space:nowrap;">
                                        {{ item.status === 'uploading' ? '上传中...' : formatDateTime(item.createTime) }}
                                    </div>
                                    <Dropdown v-if="item.status !== 'uploading'" :disabled="curState.uploading" transfer placement="bottom-end" trigger="click"
                                        @on-click="(name) => handleActionMenu(name, item)">
                                        <a href="javascript:void(0)" style="color:#999;line-height:1;padding:0 4px;">
                                            <Icon type="ios-more" :size="18"></Icon>
                                        </a>
                                        <DropdownMenu slot="list">
                                            <DropdownItem name="rename">重命名</DropdownItem>
                                            <DropdownItem name="delete">删除</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="padding-top:10px;border-top:1px solid #f0f0f0;">
                    <Pages :page="curState.page" :func="handleChangePage" :pArr="[18]" :showSizer="false" />
                </div>
            </div>
        </Modal>
        <Modal v-model="previewVisible" title="素材预览" :width="500" footer-hide :mask-closable="true" transfer @on-cancel="handlePreviewClose">
            <div style="text-align:center;">
                <div v-if="previewData.materialType === 1" style="max-width:100%;">
                    <img :src="resolveFileUrl(previewData.fileUrl) || previewData.localCover" style="max-width:100%;max-height:60vh;" />
                </div>
                <div v-else-if="previewData.materialType === 2" style="max-width:100%;display:flex;justify-content:center;">
                    <Videoplay
                        v-if="previewVisible && url"
                        :url="url"
                        :poster-url="posterUrl"
                        style="height: 600px;width: 337.5px;max-height:70vh;background:#000;border-radius:4px;"
                    />
                </div>
            </div>
        </Modal>
        <Modal v-model="setCurrentConfirmVisible" title="提示" :width="400" transfer class-name="confirm-no-border-modal">
            <div style="padding:10px 0;text-align:center;">
                <Icon type="md-information-circle" :size="20" color="#2d8cf0" style="vertical-align:middle;margin-right:8px;" />
                <span>确定将此广告素材设为当前使用？</span>
            </div>
            <div slot="footer">
                <Button @click="setCurrentConfirmVisible = false">取消</Button>
                <Button type="primary" @click="handleConfirmSetCurrent" :loading="setCurrentLoading">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import Pages from '@/components/pages'
import Videoplay from '../../components/VideoPlayer/index.vue'
import axios from 'axios'
import { setCurrentPlayAdMaterial, getFileUploadPresigned, confirmFileUploadComplete, addPlayAdMaterial, delPlayAdMaterial, updatePlayAdMaterialName, getPlayAdMaterialList } from '@/api/play-ad-material'
import config from '@/config'


const envBaseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

const resolveFileUrl = (fileUrl) => {
    if (!fileUrl) return ''
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl
    if (/^data:(image|video|audio)\//i.test(fileUrl)) return fileUrl
    if (/^blob:/i.test(fileUrl)) return fileUrl
    if (fileUrl.startsWith('//')) return window.location.protocol + fileUrl
    const base = envBaseUrl.endsWith('/') ? envBaseUrl.slice(0, -1) : envBaseUrl
    const path = fileUrl.startsWith('/') ? fileUrl : '/' + fileUrl
    return base + path
}

const readVideoDuration = (file) => {
    return new Promise((resolve) => {
        try {
            const url = URL.createObjectURL(file)
            const video = document.createElement('video')
            video.preload = 'metadata'
            video.src = url
            let handled = false
            const done = (val) => {
                if (handled) return
                handled = true
                try { URL.revokeObjectURL(url) } catch(e){}
                resolve(Math.round(Number(val) || 0))
            }
            const onLoaded = () => done(video.duration)
            video.addEventListener('loadedmetadata', onLoaded)
            video.addEventListener('durationchange', onLoaded)
            video.addEventListener('error', () => done(0))
            setTimeout(() => done(0), 8000)
        } catch (e) {
            resolve(0)
        }
    })
}

const generateVideoCover = (file) => {
    return new Promise((resolve) => {
        try {
            const url = URL.createObjectURL(file)
            const video = document.createElement('video')
            video.preload = 'metadata'
            video.muted = true
            video.playsInline = true
            video.src = url
            let handled = false
            const done = (cover) => {
                if (handled) return
                handled = true
                try { URL.revokeObjectURL(url) } catch(e){}
                resolve(cover || '')
            }
            video.addEventListener('loadeddata', () => {
                try {
                    const dur = video.duration || 0
                    const seekTime = dur > 0 ? Math.max(1, Math.min(dur * 0.1, dur - 0.5)) : 1
                    video.currentTime = seekTime
                } catch(e) {}
            })
            video.addEventListener('seeked', () => {
                try {
                    const canvas = document.createElement('canvas')
                    const w = video.videoWidth || 480
                    const h = video.videoHeight || 270
                    canvas.width = w
                    canvas.height = h
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(video, 0, 0, w, h)
                    const cover = canvas.toDataURL('image/jpeg', 0.8)
                    done(cover)
                } catch(e) {
                    done('')
                }
            })
            video.addEventListener('error', () => done(''))
            setTimeout(() => done(''), 10000)
        } catch (e) {
            resolve('')
        }
    })
}

const readImageAsDataUrl = (file) => {
    return new Promise((resolve) => {
        try {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result || '')
            reader.onerror = () => resolve('')
            reader.readAsDataURL(file)
        } catch (e) {
            resolve('')
        }
    })
}

const getImageDimensions = (dataUrl) => {
    return new Promise((resolve) => {
        if (!dataUrl) resolve({ width: 0, height: 0 })
        try {
            const img = new Image()
            let done = false
            const finish = (w, h) => {
                if (done) return
                done = true
                resolve({ width: Number(w) || 0, height: Number(h) || 0 })
            }
            img.onload = () => finish(img.naturalWidth || img.width, img.naturalHeight || img.height)
            img.onerror = () => finish(0, 0)
            img.src = dataUrl
            setTimeout(() => finish(img.width || 0, img.height || 0), 8000)
        } catch (e) {
            resolve({ width: 0, height: 0 })
        }
    })
}

const createDefaultState = () => ({
    uploading: false,
    uploadTotal: 0,
    uploadedCount: 0,
    totalSize: 0,
    uploadedSize: 0,
    page: {
        current: 1,
        size: 18,
        total: 0,
    },
    tableData: []
})

export default {
    name: 'AdMaterial',
    components: {
        Pages,
        Videoplay
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Object,
            default: () => ({})
        }
    },
    model: {
        prop: 'visible',
        event: 'update:visible'
    },
    data() {
        return {
            innerVisible: false,
            playStateMap: {},
            previewVisible: false,
            previewData: {},
            url: '',
            posterUrl: '',
            editingItem: null,
            editingName: '',
            currentUseItem: null,
            setCurrentConfirmVisible: false,
            setCurrentTarget: null,
            setCurrentLoading: false,
            saveLoading: false,
            snapshotTableData: [],
            snapshotCurrentUseItem: null,
            coverExtractedIds: {}
        }
    },
    computed: {
        playKey() {
            return this.form.id || this.form.playId || '__empty__'
        },
        curState() {
            if (!this.playStateMap[this.playKey]) {
                this.$set(this.playStateMap, this.playKey, createDefaultState())
            }
            return this.playStateMap[this.playKey]
        },
        pagedData() {
            const { page, tableData } = this.curState
            const start = (page.current - 1) * page.size
            const end = page.current * page.size
            return tableData.slice(start, end)
        },
        percentProgress() {
            const state = this.curState
            if (!state.uploading) return 0
            if (state.totalSize > 0) {
                return state.uploadedSize / state.totalSize * 100
            }
            if (state.uploadTotal > 0) {
                return state.uploadedCount / state.uploadTotal * 100
            }
            return 0
        },
        formatPercent() {
            const state = this.curState
            const p = Math.min(99, Math.round(this.percentProgress))
            return `${p}%（${state.uploadedCount}/${state.uploadTotal}）`
        },
        hasPublishedMaterial() {
            const state = this.curState || {}
            if (state.page && state.page.total > 0) return true
            const list = state.tableData || []
            return list.some(item => item.id && !String(item.id).startsWith('_tmp_'))
        },
        materialCount() {
            const list = (this.curState && this.curState.tableData) || []
            return list.filter(item =>
                item.status !== 'uploading' && item.status !== 'fail' && item.fileUrl
            ).length
        }
    },
    watch: {
        visible(val) {
            this.innerVisible = val
            if (val) {
                this.previewVisible = false
                this.handleCancelRename()
                this.currentUseItem = null
                const state = this.curState
                state.page.current = 1
                const playId = this.form.id || this.form.playId
                if (!playId) {
                    state.tableData = []
                    state.page.total = 0
                    this.takeSnapshot()
                    return
                }
                getPlayAdMaterialList({
                    current: 1,
                    size: state.page.size,
                    playId: playId
                }).then(res => {
                    const data = (res && res.data) ? res.data : (res || {})
                    const records = data.records || data.list || []
                    const total = data.total || records.length || 0
                    var rawMapped = records.map(item => {
                        const url = item.url || item.fileUrl || ''
                        const materialType = item.materialType || this.getMaterialTypeByName(url)
                        const name = item.name || item.materialName || ''
                        return {
                            ...item,
                            id: item.id,
                            materialType: materialType,
                            materialName: name,
                            fileOriginalName: item.fileOriginalName || name || '',
                            fileId: item.fileId || '',
                            fileUrl: url,
                            coverUrl: item.coverUrl || '',
                            localCover: item.localCover || '',
                            duration: Number(item.fileMediaTime || item.duration) || 0,
                            displayDuration: Number(item.displayDuration || item.fileMediaTime || item.duration) || 0,
                            createTime: item.createTime || '',
                            status: item.status !== undefined ? item.status : 1,
                            isCurrent: item.isCurrent === 1 || item.isCurrent === true
                        }
                    })
                    var sorted = this.sortTableDataByRule(rawMapped)
                    var oldList = Array.isArray(state.tableData) ? state.tableData.slice() : []
                    var merged = this.mergeLocalCovers(oldList, sorted)
                    var localOnly = oldList.filter(t => t && (t.status === 'uploading' || t.status === 'fail'))
                    var combined = localOnly.concat(merged)
                    state.tableData = this.prioritizeLocalItems(this.deduplicateById(combined))
                    state.page.total = total + localOnly.length
                    if (state.tableData.length > 0) {
                        const currentItem = state.tableData.find(t => t.isCurrent || t.currentUse || t.current) || state.tableData.find(t => t.status !== 'uploading' && t.status !== 'fail') || state.tableData[0]
                        this.currentUseItem = { ...currentItem }
                    }
                    this.takeSnapshot()
                    this.coverExtractedIds = {}
                    this.$nextTick(() => this.ensureVideoCoversForState())
                })
            }
        },
        innerVisible(val) {
            if (!val) {
                this.previewVisible = false
                this.handleCancelRename()
                document.body.style.cursor = ''
            }
            this.$emit('update:visible', val)
        },
        previewVisible(val) {
            if (!val) {
                this.handlePreviewClose()
            }
        },
        'curState.uploading'(val) {
            if (this.innerVisible) {
                document.body.style.cursor = val ? 'not-allowed' : ''
            }
        }
    },
    beforeDestroy() {
        document.body.style.cursor = ''
    },
    deactivated() {
        document.body.style.cursor = ''
    },
    methods: {
        resolveFileUrl,
        getRowIdentity(item) {
            if (!item) return ''
            return String(item.id || item.fileId || item.fileUrl || '')
        },
        mergeLocalCovers(oldList, newList) {
            if (!Array.isArray(oldList) || oldList.length === 0) return newList
            var map = {}
            for (var i = 0; i < oldList.length; i++) {
                var row = oldList[i]
                if (!row) continue
                var key = this.getRowIdentity(row)
                if (!key) continue
                if (row.localCover) map[key] = row.localCover
            }
            for (var j = 0; j < newList.length; j++) {
                var newRow = newList[j]
                if (!newRow) continue
                var k = this.getRowIdentity(newRow)
                if (!k) continue
                if (!newRow.localCover && map[k]) {
                    newRow.localCover = map[k]
                }
            }
            return newList
        },
        sortTableDataByRule(records) {
            if (!Array.isArray(records)) return []
            return records.slice()
        },
        prioritizeLocalItems(list) {
            if (!Array.isArray(list)) return []
            var localItems = []
            var otherItems = []
            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                if (item && (item.status === 'uploading' || item.status === 'fail')) {
                    localItems.push(item)
                } else {
                    otherItems.push(item)
                }
            }
            return localItems.concat(otherItems)
        },
        deduplicateById(list) {
            if (!Array.isArray(list)) return []
            var seen = {}
            var result = []
            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                if (!item) continue
                var key = this.getRowIdentity(item)
                if (key && seen[key]) continue
                if (key) seen[key] = true
                result.push(item)
            }
            return result
        },
        getColor(status) {
            const colorMap = {
                0: '#ff9900',
                1: '#00d647',
                2: '#2d8cf0'
            }
            return colorMap[status] || '#808695'
        },
        getMaterialTypeName(type) {
            const typeMap = {
                1: '图片',
                2: '视频'
            }
            return typeMap[type] || '未知'
        },
        getMaterialTypeByName(name) {
            if (!name) return 1
            const lower = name.toLowerCase()
            if (lower.endsWith('.mp4') || lower.endsWith('.mov') || lower.endsWith('.avi')) {
                return 2
            }
            return 1
        },
        formatDuration(seconds) {
            if (!seconds) return '0秒'
            const h = Math.floor(seconds / 3600)
            const m = Math.floor((seconds % 3600) / 60)
            const s = seconds % 60
            if (h > 0) return `${h}时${m}分${s}秒`
            if (m > 0) return `${m}分${s}秒`
            return `${s}秒`
        },
        formatDurationShort(seconds) {
            if (!seconds) return '0:00'
            const m = Math.floor(seconds / 60)
            const s = seconds % 60
            return `${m}:${String(s).padStart(2, '0')}`
        },
        handleClickClose(val) {
            const doClose = () => {
                this.restoreSnapshot()
                this.innerVisible = val
            }
            if (this.curState.uploading) {
                this.$Modal.warning({
                    title: '提示',
                    content: '正在上传素材中，关闭弹窗会中断上传，且本次修改不会保存，确定要关闭吗？',
                    okText: '确定关闭',
                    onOk: () => {
                        doClose()
                    }
                })
                return
            }
            doClose()
        },
        takeSnapshot() {
            const state = this.curState
            this.snapshotTableData = JSON.parse(JSON.stringify(state.tableData || []))
            this.snapshotCurrentUseItem = this.currentUseItem
                ? JSON.parse(JSON.stringify(this.currentUseItem))
                : null
        },
        restoreSnapshot() {
            const state = this.curState
            state.tableData = JSON.parse(JSON.stringify(this.snapshotTableData || []))
            state.page.total = state.tableData.length
            state.page.current = 1
            this.currentUseItem = this.snapshotCurrentUseItem
                ? JSON.parse(JSON.stringify(this.snapshotCurrentUseItem))
                : null
        },
        handleTriggerUpload() {
            this.$refs.uploadInputTop && this.$refs.uploadInputTop.click()
        },
        handleLocalUpload(e) {
            if (!e.target.files || !e.target.files.length) return
            const files = Array.from(e.target.files)
            e.target.value = ''
            this.startUpload(files)
        },
        async startUpload(files) {
            const state = this.curState
            if (state.uploading) return
            const maxSize = 25 * 1024 * 1024
            const validFiles = []
            const invalidNames = []
            for (const file of files) {
                const lowerName = (file.name || '').toLowerCase()
                const isVideo = lowerName.endsWith('.mp4') || lowerName.endsWith('.mov') || lowerName.endsWith('.avi')
                const isGif = lowerName.endsWith('.gif')
                const needCheck = isVideo || isGif
                if (needCheck && (file.size || 0) >= maxSize) {
                    invalidNames.push(file.name)
                } else {
                    validFiles.push(file)
                }
            }
            if (invalidNames.length > 0) {
                this.$Modal.warning({
                    title: '提示',
                    content: `以下${invalidNames.length}个文件超过大小限制（<25MB），已自动跳过：<br/>${invalidNames.join('<br/>')}`
                })
            }
            if (validFiles.length === 0) return
            state.uploading = true
            state.uploadTotal = validFiles.length
            state.uploadedCount = 0
            state.totalSize = validFiles.reduce((sum, f) => sum + (f.size || 0), 0)
            state.uploadedSize = 0
            let completedFilesSize = 0

            for (let i = 0; i < validFiles.length; i++) {
                const file = validFiles[i]
                const materialType = this.getMaterialTypeByName(file.name)
                const tempId = Date.now() + Math.random()
                let displayDuration = 0
                let localCover = ''
                let imgWidth = 0
                let imgHeight = 0
                if (materialType === 2) {
                    try {
                        const [dur, cover] = await Promise.all([
                            readVideoDuration(file),
                            generateVideoCover(file)
                        ])
                        displayDuration = dur
                        localCover = cover
                    } catch(e) {
                        displayDuration = 0
                        localCover = ''
                    }
                } else {
                    try {
                        localCover = await readImageAsDataUrl(file)
                        if (localCover) {
                            const dims = await getImageDimensions(localCover)
                            imgWidth = dims.width
                            imgHeight = dims.height
                        }
                    } catch(e) {
                        localCover = ''
                        imgWidth = 0
                        imgHeight = 0
                    }
                }
                const tempItem = {
                    id: tempId,
                    materialType,
                    materialName: file.name.replace(/\.[^.]+$/, ''),
                    fileOriginalName: file.name,
                    fileId: '',
                    fileUrl: '',
                    duration: 0,
                    displayDuration,
                    localCover,
                    imgWidth,
                    imgHeight,
                    status: 'uploading',
                    createTime: ''
                }
                state.tableData.unshift(tempItem)
                state.page.total = state.tableData.length

                try {
                    const fileSize = file.size || 0
                    const fileType = materialType === 1 ? 'image' : 'video'
                    const originName = file.name || ''
                    const safeName = originName.length > 50 ? originName.slice(0, 50) : originName
                    const presignRes = await getFileUploadPresigned({
                        directory: 'DRAMA_MATERIAL',
                        name: safeName
                    })
                    const presign = presignRes && presignRes.data ? presignRes.data : (presignRes || {})
                    const uploadUrl = presign.uploadUrl || presign.url || ''
                    const fileIdFromPresign = presign.fileId !== undefined ? String(presign.fileId) : ''
                    if (!uploadUrl) throw new Error('未获取到上传地址')
                    await axios.request({
                        url: uploadUrl,
                        method: 'put',
                        data: file,
                        headers: {
                            'Content-Type': file.type || 'application/octet-stream'
                        },
                        onUploadProgress: (progressEvent) => {
                            if (progressEvent.total > 0) {
                                const currentUploaded = progressEvent.loaded
                                state.uploadedSize = completedFilesSize + currentUploaded
                            } else if (fileSize > 0) {
                                const estimated = progressEvent.loaded > fileSize ? fileSize : progressEvent.loaded
                                state.uploadedSize = completedFilesSize + estimated
                            }
                        }
                    })
                    const completeParams = {
                        fileId: fileIdFromPresign || '',
                        fileMediaTime: displayDuration || 0,
                        imgHeight: Number(tempItem.imgHeight) || 0,
                        imgWidth: Number(tempItem.imgWidth) || 0
                    }
                    if (materialType === 1 && (!completeParams.imgHeight || !completeParams.imgWidth) && tempItem.localCover) {
                        try {
                            const dims = await getImageDimensions(tempItem.localCover)
                            completeParams.imgHeight = dims.height
                            completeParams.imgWidth = dims.width
                        } catch (e) {}
                    }
                    const completeRes = await confirmFileUploadComplete(completeParams)
                    const fileInfo = completeRes && completeRes.data ? completeRes.data : (completeRes || {})
                    completedFilesSize += fileSize
                    state.uploadedSize = completedFilesSize
                    const idx = state.tableData.findIndex(t => t.id === tempId)
                    let newItem = null
                    if (idx > -1) {
                        newItem = {
                            ...tempItem,
                            fileId: String(fileInfo.id || fileInfo.fileId || fileIdFromPresign || ''),
                            fileUrl: fileInfo.fileUrl || fileInfo.filePath || presign.url || '',
                            coverUrl: fileInfo.coverUrl || '',
                            status: 1,
                            materialName: tempItem.materialName,
                            fileOriginalName: fileInfo.fileOriginalName || fileInfo.fileName || file.name,
                            duration: Number(fileInfo.fileMediaTime) || displayDuration || 0,
                            displayDuration: displayDuration || Number(fileInfo.fileMediaTime) || 0,
                            createTime: fileInfo.createTime || this.formatDate(new Date())
                        }
                        state.tableData.splice(idx, 1, newItem)
                    }
                    if (newItem) {
                        this.currentUseItem = { ...newItem }
                        const playId = this.form.id || this.form.playId
                        const newFileId = newItem.fileId || ''
                        if (playId) {
                            try {
                                const params = {
                                    name: newItem.materialName || newItem.fileOriginalName || '未命名',
                                    playId: playId,
                                    url: newItem.fileUrl || '',
                                    fileMediaTime: Number(newItem.displayDuration || newItem.duration) || 0
                                }
                                await addPlayAdMaterial(params)
                                const listRes = await getPlayAdMaterialList({
                                    current: 1,
                                    size: Math.max(state.page.size, state.tableData.length + 10),
                                    playId: playId
                                })
                                const listData = (listRes && listRes.data) ? listRes.data : (listRes || {})
                                const records = (listData.records || listData.list || []).map(item => {
                                    const url = item.url || item.fileUrl || ''
                                    const materialType = item.materialType || this.getMaterialTypeByName(url)
                                    const name = item.name || item.materialName || ''
                                    return {
                                        ...item,
                                        id: item.id,
                                        materialType: materialType,
                                        materialName: name,
                                        fileOriginalName: item.fileOriginalName || name || '',
                                        fileId: item.fileId || '',
                                        fileUrl: url,
                                        coverUrl: item.coverUrl || '',
                                        localCover: item.localCover || '',
                                        duration: Number(item.fileMediaTime || item.duration) || 0,
                                        displayDuration: Number(item.displayDuration || item.fileMediaTime || item.duration) || 0,
                                        createTime: item.createTime || '',
                                        status: item.status !== undefined ? item.status : 1,
                                        isCurrent: item.isCurrent === 1 || item.isCurrent === true
                                    }
                                })
                                var sortedRecords = this.sortTableDataByRule(records)
                                var oldRecords = Array.isArray(state.tableData) ? state.tableData.slice() : []
                                var merged = this.mergeLocalCovers(oldRecords, sortedRecords)
                                var localOnly = oldRecords.filter(t => t && (t.status === 'uploading' || t.status === 'fail'))
                                var combined = localOnly.concat(merged)
                                state.tableData = this.prioritizeLocalItems(this.deduplicateById(combined))
                                state.page.total = (listData.total || 0) + localOnly.length
                                state.page.current = 1
                                this.coverExtractedIds = {}
                                this.$nextTick(() => this.ensureVideoCoversForState())
                                const freshItem = merged.find(r => (r.fileId && newFileId && r.fileId === newFileId))
                                    || (merged.length > 0 ? merged[0] : null)
                                if (freshItem) {
                                    this.currentUseItem = { ...freshItem }
                                }
                                if (freshItem && freshItem.id) {
                                    try {
                                        await setCurrentPlayAdMaterial(freshItem.id)
                                        const afterIdx = state.tableData.findIndex(r => r.id === freshItem.id)
                                        if (afterIdx > -1) {
                                            this.currentUseItem = { ...state.tableData[afterIdx] }
                                        }
                                    } catch (e) {}
                                }
                            } catch (e) {}
                        }
                    }
                    state.uploadedCount++
                } catch (err) {
                    completedFilesSize += file.size || 0
                    state.uploadedSize = completedFilesSize
                    const idx = state.tableData.findIndex(t => t.id === tempId)
                    if (idx > -1) {
                        state.tableData.splice(idx, 1, {
                            ...tempItem,
                            status: 'fail',
                            createTime: this.formatDate(new Date())
                        })
                    }
                    state.uploadedCount++
                    this.$Message.error(`${file.name} 上传失败`)
                }
            }

            state.uploading = false
            const successCount = state.uploadTotal - state.tableData.filter(t => t.status === 'fail').length
            if (successCount === state.uploadTotal) {
                this.$Message.success(`上传成功，共 ${state.uploadTotal} 个文件`)
            } else {
                this.$Message.warning(`上传完成：成功 ${successCount} 个，失败 ${state.uploadTotal - successCount} 个`)
            }
        },
        getData(page) {
            const state = this.curState
            if (page) state.page.current = page
            else state.page.current = 1
            const playId = this.form.id || this.form.playId
            if (!playId) {
                state.tableData = []
                state.page.total = 0
                this.currentUseItem = null
                return
            }
            getPlayAdMaterialList({
                current: state.page.current,
                size: state.page.size,
                playId: playId
            }).then(res => {
                const data = (res && res.data) ? res.data : (res || {})
                const records = data.records || data.list || []
                const total = data.total || records.length || 0
                var rawMapped = records.map(item => {
                    const url = item.url || item.fileUrl || ''
                    const materialType = item.materialType || this.getMaterialTypeByName(url)
                    const name = item.name || item.materialName || ''
                    return {
                        ...item,
                        id: item.id,
                        materialType: materialType,
                        materialName: name,
                        fileOriginalName: item.fileOriginalName || name || '',
                        fileId: item.fileId || '',
                        fileUrl: url,
                        coverUrl: item.coverUrl || '',
                        localCover: item.localCover || '',
                        duration: Number(item.fileMediaTime || item.duration) || 0,
                        displayDuration: Number(item.displayDuration || item.fileMediaTime || item.duration) || 0,
                        createTime: item.createTime || '',
                        status: item.status !== undefined ? item.status : 1,
                        isCurrent: item.isCurrent === 1 || item.isCurrent === true
                    }
                })
                var sorted = this.sortTableDataByRule(rawMapped)
                var oldList = Array.isArray(state.tableData) ? state.tableData.slice() : []
                var merged = this.mergeLocalCovers(oldList, sorted)
                var localOnly = oldList.filter(t => t && (t.status === 'uploading' || t.status === 'fail'))
                var combined = localOnly.concat(merged)
                state.tableData = this.prioritizeLocalItems(this.deduplicateById(combined))
                state.page.total = total + localOnly.length
                if (!this.currentUseItem && state.tableData.length > 0) {
                    const currentItem = state.tableData.find(t => t.isCurrent || t.currentUse || t.current) || state.tableData.find(t => t.status !== 'uploading' && t.status !== 'fail') || state.tableData[0]
                    this.currentUseItem = { ...currentItem }
                } else if (this.currentUseItem) {
                    const exist = state.tableData.find(t => t.id === this.currentUseItem.id)
                    if (exist) {
                        this.currentUseItem = { ...exist }
                    } else if (state.tableData.length > 0) {
                        const currentItem = state.tableData.find(t => t.isCurrent || t.currentUse || t.current) || state.tableData.find(t => t.status !== 'uploading' && t.status !== 'fail') || state.tableData[0]
                        this.currentUseItem = { ...currentItem }
                    } else {
                        this.currentUseItem = null
                    }
                }
                this.coverExtractedIds = {}
                this.$nextTick(() => this.ensureVideoCoversForState())
            })
        },
        handleChangePage(page) {
            this.getData(page)
        },
        formatDate(date) {
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            const hh = String(date.getHours()).padStart(2, '0')
            const mm = String(date.getMinutes()).padStart(2, '0')
            return `${y}-${m}-${d} ${hh}:${mm}`
        },
        formatDateTime(val) {
            if (!val && val !== 0) return '-'
            try {
                let d
                if (typeof val === 'number' || /^\d+$/.test(String(val))) {
                    const n = Number(val)
                    d = new Date(n < 1e12 ? n * 1000 : n)
                } else {
                    d = new Date(val)
                }
                if (isNaN(d.getTime())) return '-'
                return this.formatDate(d)
            } catch (e) {
                return '-'
            }
        },
        handleActionMenu(name, item) {
            if (name === 'delete') {
                this.handleDelete(item)
            } else if (name === 'rename') {
                this.handleStartRename(item)
            } else if (name === 'setCurrent') {
                this.handleSetCurrent(item)
            }
        },
        handleSetCurrent(item) {
            if (this.curState.uploading || item.status === 'uploading') return
            this.setCurrentTarget = item
            this.setCurrentConfirmVisible = true
        },
        handleClickCurrentUse(item) {
            if (!item) return
            this.$Message.info('当前已使用')
        },
        handleConfirmSetCurrent() {
            if (!this.setCurrentTarget || this.setCurrentLoading) return
            if (!this.setCurrentTarget.id) {
                this.$Message.warning('素材未保存，请先保存后再设置当前使用')
                return
            }
            const state = this.curState
            this.setCurrentLoading = true
            setCurrentPlayAdMaterial(this.setCurrentTarget.id).then(() => {
                const idx = state.tableData.findIndex(i => i.id === this.setCurrentTarget.id)
                if (idx > -1) {
                    this.currentUseItem = { ...state.tableData[idx] }
                }
                this.setCurrentConfirmVisible = false
                this.setCurrentTarget = null
                this.$Message.success('切换成功')
            }).finally(() => {
                this.setCurrentLoading = false
            })
        },
        handleDelete(row) {
            const state = this.curState
            if (state.uploading || row.status === 'uploading') return
            this.$Modal.confirm({
                title: '提示',
                content: '确定要删除该素材吗？',
                onOk: async () => {
                    if (row.id) {
                        try {
                            await delPlayAdMaterial(row.id)
                        } catch (e) {}
                    }
                    const wasCurrentUse = this.currentUseItem && this.currentUseItem.id === row.id
                    const index = state.tableData.findIndex(i => i.id === row.id)
                    if (index > -1) {
                        state.tableData.splice(index, 1)
                        state.page.total = state.tableData.length
                        const maxPage = Math.max(1, Math.ceil(state.tableData.length / state.page.size))
                        if (state.page.current > maxPage) {
                            state.page.current = maxPage
                        }
                    }
                    if (wasCurrentUse) {
                        const remaining = state.tableData.filter(t =>
                            t.status !== 'uploading' && t.status !== 'fail' && t.fileUrl
                        )
                        if (remaining.length > 0) {
                            this.currentUseItem = { ...remaining[0] }
                        } else {
                            this.currentUseItem = null
                        }
                    }
                    this.$Message.success('删除成功')
                },
                onCancel: () => {
                    this.$Message.info('已取消删除')
                }
            })
        },
        handleStartRename(row) {
            if (this.curState.uploading || row.status === 'uploading') return
            this.editingItem = row
            this.editingName = row.materialName || row.fileOriginalName || ''
            this.$nextTick(() => {
                if (this.$refs.renameInput) {
                    const input = this.$refs.renameInput
                    if (Array.isArray(input)) {
                        input[0] && input[0].focus()
                    } else {
                        input && input.focus()
                    }
                }
            })
        },
        handleFinishRename(row) {
            const name = (this.editingName || '').trim()
            const oldName = row.materialName || row.fileOriginalName || ''
            if (!name) {
                this.$Message.warning('素材名称不能为空')
                this.editingItem = null
                this.editingName = ''
                return
            }
            if (name === oldName) {
                this.editingItem = null
                this.editingName = ''
                return
            }
            const state = this.curState
            const idx = state.tableData.findIndex(i => i.id === row.id)
            if (idx > -1) {
                state.tableData[idx].materialName = name
            }
            if (row.id) {
                updatePlayAdMaterialName({
                    id: row.id,
                    name: name
                }).catch(() => {})
            }
            this.editingItem = null
            this.editingName = ''
        },
        handleCancelRename() {
            this.editingItem = null
            this.editingName = ''
        },
        handlePreview(row) {
            if (this.curState.uploading) return
            this.previewData = { ...row }
            this.previewVisible = true
        },
        handlePreviewCard(row) {
            if (this.curState.uploading || row.status === 'uploading') return
            this.previewData = { ...row }
            this.url = resolveFileUrl(row.fileUrl || '')
            this.posterUrl = resolveFileUrl(row.coverUrl || row.localCover || '')
            this.previewVisible = true
        },
        handlePreviewClose() {
            this.url = ''
            this.posterUrl = ''
        },
        ensureVideoCoversForState() {
            var self = this
            const state = this.curState
            if (!state || !state.tableData) return
            var findTarget = function (rowKey) {
                var list = state.tableData
                if (!list) return null
                for (var i = 0; i < list.length; i++) {
                    if (self.getRowIdentity(list[i]) === rowKey) return list[i]
                }
                return null
            }
            state.tableData.forEach((row, idx) => {
                if (row.materialType !== 2) return
                if (row.coverUrl || row.localCover) return
                const rowKey = this.getRowIdentity(row)
                const key = rowKey || String(idx)
                if (this.coverExtractedIds[key]) return
                this.coverExtractedIds[key] = true
                const videoUrl = resolveFileUrl(row.fileUrl || '')
                if (!videoUrl) return
                var applyCover = function (dataUrl) {
                    var target = rowKey ? findTarget(rowKey) : null
                    if (!target && state.tableData && idx < state.tableData.length) {
                        target = state.tableData[idx]
                    }
                    if (!target || typeof target !== 'object') return
                    if (!target.coverUrl && !target.localCover) {
                        self.$set(target, 'localCover', dataUrl)
                    }
                }
                try {
                    const video = document.createElement('video')
                    video.preload = 'auto'
                    video.muted = true
                    video.playsInline = true
                    video.crossOrigin = 'anonymous'
                    video.src = videoUrl
                    var retryCount = 0
                    var maxRetry = 2
                    var disposed = false
                    var dispose = function () {
                        if (disposed) return
                        disposed = true
                        try { video.pause() } catch (e) {}
                        try { video.src = ''; video.removeAttribute('src') } catch (e) {}
                        try { video.load && video.load() } catch (e) {}
                    }
                    const tryExtract = () => {
                        if (disposed) return
                        try {
                            var duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 0
                            var seek
                            if (duration > 0) {
                                var ratio = retryCount === 0 ? (1 / 3) : 0.5
                                var pos = duration * ratio
                                var minSeek = duration >= 12 ? 3 : (duration >= 6 ? 2 : (duration >= 3 ? 1 : 0.5))
                                seek = Math.min(duration - 0.8, Math.max(minSeek, pos))
                            } else {
                                seek = retryCount === 0 ? 0.8 : 1.5
                            }
                            video.currentTime = Math.max(0, seek)
                        } catch (e) {
                            dispose()
                            return
                        }
                        const onSeek = () => {
                            if (disposed) return
                            try {
                                video.removeEventListener('seeked', onSeek)
                                const w = video.videoWidth || 480
                                const h = video.videoHeight || 270
                                const canvas = document.createElement('canvas')
                                canvas.width = w
                                canvas.height = h
                                const ctx = canvas.getContext('2d')
                                ctx.drawImage(video, 0, 0, w, h)
                                var dataUrl = ''
                                try {
                                    dataUrl = canvas.toDataURL('image/jpeg', 0.85)
                                } catch (err) {
                                    try { dataUrl = canvas.toDataURL('image/png') } catch (e3) {}
                                }
                                var usable = dataUrl && dataUrl.length > 100
                                if (usable) {
                                    var sampleW = 16
                                    var sampleH = 9
                                    try {
                                        var small = document.createElement('canvas')
                                        small.width = sampleW
                                        small.height = sampleH
                                        var sctx = small.getContext('2d')
                                        sctx.drawImage(video, 0, 0, sampleW, sampleH)
                                        var imgData = sctx.getImageData(0, 0, sampleW, sampleH).data
                                        var total = 0
                                        for (var i = 0; i < imgData.length; i += 4) {
                                            total += 0.299 * imgData[i] + 0.587 * imgData[i + 1] + 0.114 * imgData[i + 2]
                                        }
                                        var avg = total / (sampleW * sampleH)
                                        if (avg < 22 && retryCount < maxRetry) {
                                            usable = false
                                        }
                                    } catch (e) {}
                                }
                                if (usable) {
                                    applyCover(dataUrl)
                                    dispose()
                                } else if (retryCount < maxRetry) {
                                    retryCount++
                                    setTimeout(tryExtract, 200)
                                } else {
                                    if (dataUrl) applyCover(dataUrl)
                                    dispose()
                                }
                            } catch (e) {
                                dispose()
                            }
                        }
                        video.addEventListener('seeked', onSeek)
                        setTimeout(function () {
                            if (disposed) return
                            onSeek()
                        }, 5000)
                    }
                    const onReady = () => {
                        if (disposed) return
                        try {
                            video.removeEventListener('loadeddata', onReady)
                            video.removeEventListener('canplay', onReady)
                            video.removeEventListener('canplaythrough', onReady)
                            retryCount = 0
                            tryExtract()
                        } catch (e) {
                            dispose()
                        }
                    }
                    video.addEventListener('loadeddata', onReady)
                    video.addEventListener('canplay', onReady)
                    video.addEventListener('canplaythrough', onReady)
                    setTimeout(function () {
                        if (disposed) return
                        onReady()
                    }, 9000)
                } catch (e) {}
            })
        },
    }
}
</script>

<style scoped lang="less">
/deep/ .ivu-modal-header {
    padding: 16px 24px;
}
/deep/ .ivu-modal-body {
    padding: 0;
}
/deep/ .ivu-modal-footer {
    padding: 12px 24px;
}
/deep/ .ivu-modal-header-inner {
    height: auto;
}
/deep/ .confirm-no-border-modal .ivu-modal-header {
    border-bottom: none;
}
/deep/ .confirm-no-border-modal .ivu-modal-footer {
    border-top: none;
}
</style>